// extracted by mini-css-extract-plugin
export default {"pageLayout":"Tags-module__pageLayout___QHB1A"};